<div *ngIf="loading" class="graph loading" id="reportChart" [chart]="reportChart"></div>
<div *ngIf="!loading" class="graph" id="dailyChurnRate" [chart]="reportChart"></div>